import { CustomLoader } from "@/components/Loader";
import { Suspense } from "react";

export const withSuspense = (Component: React.ReactNode) => (
    <Suspense fallback={<CustomLoader />}>
        {Component}
    </Suspense>
)
